import { render } from "./ModelInTable.vue?vue&type=template&id=6a3572eb"
import script from "./ModelInTable.vue?vue&type=script&lang=js"
export * from "./ModelInTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__